import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-wavy-circle-3",
  "use": "foquz-icon-wavy-circle-3-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-wavy-circle-3\"><circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"#ECEFF1\" /><path d=\"M5 8h6\" stroke=\"#000\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol